<template>
  <div>
    <b-row
      v-for="(row,index) in inputs"
      :key="index"
    >
      <b-col
        v-for="(singleInput,loopIndex) in row.singleRow.rowInputs"
        :key="loopIndex"
        :md="singleInput.md"
      >
        <GlobalSingleInput
          :key="loopIndex"
          :input="singleInput"
          :readOnly="readOnly || singleInput.disabled"
        />
      </b-col>
    </b-row>

    <b-row v-if="selectedCrimes.length">
      <b-col cols="12">
        <label>{{ $t('label.crimesDetails') }}</label>
        <b-table
          ref="refCrimeListTable"
          hover
          responsive
          primary-key="id"
          show-empty=""
          :items="selectedCrimes"
          :fields="tableColumns"
        >
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BTable } from 'bootstrap-vue'
import { ref, reactive, watch, computed } from '@vue/composition-api'
import GlobalSingleInput from '@/views/components/form/GlobalSingleInput.vue'
import { convertInputsToKeyValuePair } from '@/helpers/objectHelper'
import _ from 'lodash'
import i18n from '@/libs/i18n'
import useCommon from "@/views/organization/useCommon"
import { probabilityValues, impactValues } from '@/constants'

export default {
  name: i18n.t('label.identification'),
  components: {
    GlobalSingleInput,
    BTable,
  },
  props: ['data', 'crimes', 'crimesData', 'areas', 'readOnly', 'residualRisks', 'probabilityOptions', 'impactOptions', 'companies', 'ids'],
  setup(props) {
    const { getRiskValue, getRiskCategoryFromNumeric } = useCommon()
    
    const inputs = reactive([
      {
        singleRow:
            {
              rowAttributes: {},
              rowInputs: [
                {
                  md: 6,
                  label: i18n.t('label.Name'),
                  type: 'text',
                  key: 'name',
                  rules: 'required',
                  placeholder: i18n.t('placeholder.name'),
                  value: '',
                },
                {
                  md: 4,
                  label: i18n.t('label.businessActivity'),
                  type: 'select',
                  key: 'id',
                  rules: '',
                  placeholder: i18n.t('placeholder.id'),
                  value: [],
                  options: props.ids,
                },
              ],
            },
      },
      {
        singleRow:
            {
              rowAttributes: {},
              rowInputs: [
                {
                  md: 12,
                  label: i18n.t('label.processActivities'),
                  type: 'textarea',
                  key: 'processActivities',
                  rules: '',
                  placeholder: i18n.t('placeholder.processActivities'),
                  value: '',
                },
              ],
            },
      },
      {
        singleRow:
            {
              rowAttributes: {},
              rowInputs: [
                {
                  md: 4,
                  label: i18n.t('label.company'),
                  type: 'select',
                  key: 'company',
                  rules: '',
                  placeholder: i18n.t('placeholder.company'),
                  value: [],
                  options: props.companies,
                },
                {
                  md: 2,
                  label: 'ID',
                  type: 'text',
                  key: 'code',
                  rules: '',
                  placeholder: i18n.t('placeholder.code'),
                  value: '',
                },
                {
                  md: 4,
                  label: i18n.t('label.operationalAreas'),
                  type: 'select',
                  key: 'areas',
                  rules: '',
                  placeholder: i18n.t('placeholder.operationalAreas'),
                  value: [],
                  options: props.areas,
                  multiple: true
                },
              ],
            },
      },
      {
        singleRow:
            {
              rowAttributes: {},
              rowInputs: [
                {
                  md: 4,
                  label: i18n.t('message.tableHeader.inherentRiskProbability'),
                  type: 'select',
                  key: 'inherentRiskProbability',
                  rules: '',
                  placeholder: i18n.t('placeholder.probability'),
                  value: '',
                  options: props.probabilityOptions,
                },
                {
                  md: 4,
                  label: i18n.t('message.tableHeader.inherentRiskImpact'),
                  type: 'select',
                  key: 'inherentRiskImpact',
                  rules: '',
                  placeholder: i18n.t('placeholder.impact'),
                  value: '',
                  options: props.impactOptions,
                },
                {
                  md: 4,
                  label: i18n.t('message.tableHeader.inherentRisk'),
                  type: 'select',
                  key: 'inherentRisk',
                  rules: '',
                  placeholder: i18n.t('placeholder.probabilityAndImpact'),
                  value: '',
                  options: props.residualRisks,
                  disabled: true
                },
              ],
            },
      },
      {
        singleRow:
            {
              rowAttributes: {},
              rowInputs: [
                {
                  md: 4,
                  label: i18n.t('message.tableHeader.residualRiskProbability'),
                  type: 'select',
                  key: 'residualRiskProbability',
                  rules: '',
                  placeholder: i18n.t('placeholder.probability'),
                  value: '',
                  options: props.probabilityOptions,
                },
                {
                  md: 4,
                  label: i18n.t('message.tableHeader.residualRiskImpact'),
                  type: 'select',
                  key: 'residualRiskImpact',
                  rules: '',
                  placeholder: i18n.t('placeholder.impact'),
                  value: '',
                  options: props.impactOptions,
                },
                {
                  md: 4,
                  label: i18n.t('message.tableHeader.residualRisk'),
                  type: 'select',
                  key: 'residualRisk',
                  rules: '',
                  placeholder: i18n.t('placeholder.probabilityAndImpact'),
                  value: '',
                  options: props.residualRisks,
                  disabled: true
                },
              ],
            },
      },
      {
        singleRow:
            {
              rowAttributes: {},
              rowInputs: [
                {
                  md: 6,
                  label: i18n.t('label.crimes'),
                  type: 'select',
                  key: 'crimes',
                  rules: '',
                  placeholder: i18n.t('placeholder.crimes'),
                  value: [],
                  options: props.crimes,
                  multiple: true
                },
                {
                  md: 6,
                  label: i18n.t('label.goal'),
                  type: 'textarea',
                  key: 'goal',
                  rules: '',
                  placeholder: i18n.t('placeholder.goal'),
                  value: '',
                  description: '',
                },
                // {
                //   md: 6,
                //   label: i18n.t('label.assumptions'),
                //   type: 'textarea',
                //   key: 'assumptions',
                //   rules: '',
                //   placeholder: i18n.t('placeholder.assumptions'),
                //   value: '',
                //   description: '',
                // },
              ],
            },
      },
      {
        singleRow:
            {
              rowAttributes: {},
              rowInputs: [
                {
                  md: 12,
                  label: i18n.t('label.riskCausesFactors'),
                  type: 'textarea',
                  key: 'riskCausesFactors',
                  rules: '',
                  placeholder: i18n.t('placeholder.riskCausesFactors'),
                  value: '',
                },
              ],
            },
      },
    ])

    const getData = () => ({ identification: convertInputsToKeyValuePair(inputs) })

    const selectedCrimes = ref([])

    const tableColumns = computed(() => {
      return [
        { key: 'name', label: i18n.t('message.tableHeader.name'), sortable: true },
        { key: 'lawNumber', label: i18n.t('label.lawNumber'), sortable: true },
        { key: 'law', label: i18n.t('label.lawName'), sortable: true },
        { key: 'article', label: i18n.t('label.article'), sortable: true },
        { key: 'number', label: i18n.t('label.number'), sortable: true },
        { key: 'description', label: i18n.t('message.tableHeader.description'), sortable: true },
      ]
    })

    const updateSelectedCrimesData = (crimes, crimesData) => {
      if (crimes?.length && crimesData?.length) {
        const crimesIds = crimes.map(crime => crime.value)
        selectedCrimes.value = crimesData.filter(crime => crimesIds.includes(crime._id))
      } else {
        selectedCrimes.value = [] // Clear table if no crimes are selected
      }
    }

    // Watch the selected crimes input field
    watch(() => inputs[5].singleRow.rowInputs.find(input => input.key === 'crimes').value,
      crimes => updateSelectedCrimesData(crimes, props.crimesData),
      { deep: true }
    )

    // Watch the crimes data because it may be loaded after the selected crimes are set
    watch(() => props.crimesData, crimesData => {
      const crimes = inputs[5].singleRow.rowInputs.find(input => input.key === 'crimes').value

      updateSelectedCrimesData(crimes, crimesData)
    }, { deep: true, immediate: true })

    watch(() => props.crimes, data => {
      inputs[5].singleRow.rowInputs[0].options = data
    }, { deep: true, immediate: true })

    watch(() => props.areas, data => {
      inputs[2].singleRow.rowInputs[2].options = data
    }, { deep: true, immediate: true })

    watch(() => props.companies, data => {
      inputs[2].singleRow.rowInputs[0].options = data
    }, { deep: true, immediate: true })

    watch(() => props.ids, data => {
      inputs[0].singleRow.rowInputs[1].options = data
    }, { deep: true, immediate: true })

    watch(() => props.data, data => {
      if (data) {
        // eslint-disable-next-line no-restricted-syntax
        for (const [key, value] of Object.entries(data)) {
          inputs.forEach(row => {
            if (_.find(row.singleRow.rowInputs, { key })) {
              _.find(row.singleRow.rowInputs, { key }).value = value
            }
          })
        }
      }
    }, { deep: true, immediate: true })

    // Watch para calcular Inherent Risk automáticamente
    watch(
      () => [
        inputs[3].singleRow.rowInputs.find(input => input.key === 'inherentRiskProbability')?.value,
        inputs[3].singleRow.rowInputs.find(input => input.key === 'inherentRiskImpact')?.value
      ],
      ([probability, impact]) => {
        const riskValue = getRiskValue(probability?.value, impact?.value)
        const inherentRiskInput = inputs[3].singleRow.rowInputs.find(input => input.key === 'inherentRisk')
        if (inherentRiskInput && riskValue) {
          // Calcular el valor numérico
          const numericValue = probabilityValues[probability?.value] * impactValues[impact?.value]
          // Agregar el valor numérico entre paréntesis al título
          inherentRiskInput.value = {
            ...riskValue,
            title: `${riskValue.title} (${numericValue})`
          }
        }
      },
      { deep: true }
    )

    // Watch para calcular Residual Risk automáticamente
    // Prioriza residualRiskNumeric si existe (de evaluaciones), sino calcula desde probabilidad × impacto
    watch(
      () => [
        inputs[4].singleRow.rowInputs.find(input => input.key === 'residualRiskProbability')?.value,
        inputs[4].singleRow.rowInputs.find(input => input.key === 'residualRiskImpact')?.value,
        props.data?.residualRiskNumeric
      ],
      ([probability, impact, residualRiskNumeric]) => {
        const residualRiskInput = inputs[4].singleRow.rowInputs.find(input => input.key === 'residualRisk')

        if (residualRiskInput) {
          // Si existe residualRiskNumeric (de evaluaciones previas), usar ese valor
          if (residualRiskNumeric) {
            // Calcular la categoría correcta desde el valor numérico
            const riskCategory = getRiskCategoryFromNumeric(residualRiskNumeric)
            const riskTitle = i18n.t(`residualRisk.${riskCategory}`)
            residualRiskInput.value = {
              value: riskCategory,
              title: `${riskTitle} (${residualRiskNumeric})`
            }
          } else {
            // Si no existe, calcular desde probabilidad × impacto original
            const riskValue = getRiskValue(probability?.value, impact?.value)
            if (riskValue) {
              const numericValue = probabilityValues[probability?.value] * impactValues[impact?.value]
              residualRiskInput.value = {
                ...riskValue,
                title: `${riskValue.title} (${numericValue})`
              }
            }
          }
        }
      },
      { deep: true, immediate: true }
    )

    return {
      inputs,
      getData,
      selectedCrimes,
      tableColumns,
    }
  },
}
</script>

<style scoped>

</style>
